const initialState = {
    tags: [],
    creations: [],
    loading: false,
    heatmap: null,
    error: null
};

const heatmapReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_HEATMAP_TAGS_REQUEST':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_HEATMAP_TAGS_SUCCESS':
            return {
                ...state,
                loading: false,
                tags: action.payload || [],
                error: null
            };

        case 'FETCH_HEATMAP_TAGS_FAILURE':
            return {
                ...state,
                loading: false,
                tags: [],
                error: action.payload
            };

        case 'SET_HEATMAP_TAGS':
            return {
                ...state,
                tags: action.payload
            };

        case 'FETCH_HEATMAP_REQUEST':
            return {
                ...state,
                loading: true,
                error: null
            };      

        case 'FETCH_HEATMAP_SUCCESS':
            return {
                ...state,
                loading: false,
                heatmap: action.payload
            };

        case 'FETCH_HEATMAP_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case 'FETCH_CREATIONS_BY_TAGS_REQUEST':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_CREATIONS_BY_TAGS_SUCCESS':
            return {
                ...state,
                loading: false,
                creations: action.payload
            };

        case 'FETCH_CREATIONS_BY_TAGS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case 'CLEAR_HEAT_MAP':
            return {
                ...state,
                clear_heatmap: action.payload
            };
        default:
            return state;
    }
};

export default heatmapReducer;